<template>
  <teleport to="body">
    <div class="report-overlay" v-if="visible" @click.self="onCancel">
      <div class="report-dialog">
        <div class="report-header">
          <h3>举报内容</h3>
          <button class="close-button" @click="onCancel">&times;</button>
        </div>
        <div class="report-body">
          <div class="form-group">
            <label>姓名 <span class="required">*</span></label>
            <input 
              type="text" 
              v-model="reportData.name" 
              class="form-input" 
              placeholder="请输入您的姓名"
            />
          </div>
          
          <div class="form-group">
            <label>联系电话 <span class="required">*</span></label>
            <input 
              type="text" 
              v-model="reportData.phone" 
              class="form-input" 
              placeholder="请输入您的联系电话"
              maxlength="11"
            />
          </div>
          
          <div class="form-group">
            <label>举报内容 <span class="required">*</span></label>
            <textarea 
              v-model="reportData.content" 
              class="form-textarea" 
              placeholder="请详细描述您要举报的内容"
              rows="5"
            ></textarea>
          </div>
          
          <!-- 附件上传（可选功能） -->
          <!-- <div class="form-group">
            <label>附件（可选）</label>
            <input type="file" @change="handleFileUpload" multiple class="file-input" />
            <div class="uploaded-files" v-if="reportData.attachments.length > 0">
              <div v-for="(file, index) in reportData.attachments" :key="index" class="file-item">
                <span>{{ file.name }}</span>
                <button class="remove-file" @click="removeFile(index)">&times;</button>
              </div>
            </div>
          </div> -->
        </div>
        
        <div class="report-footer">
          <button 
            class="cancel-btn" 
            @click="onCancel"
          >
            取消
          </button>
          <button 
            class="submit-btn" 
            @click="submitReport"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? '提交中...' : '提交举报' }}
          </button>
        </div>
        
        <!-- 提示消息 -->
        <div v-if="message.show" class="report-message" :class="message.type">
          {{ message.text }}
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { createReport } from '../api';

export default {
  name: 'ReportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    resourceType: {
      type: String,
      required: true
    },
    resourceId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      reportData: {
        name: '',
        phone: '',
        content: '',
        attachments: []
      },
      isSubmitting: false,
      message: {
        show: false,
        text: '',
        type: 'info'
      }
    };
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
      this.resetForm();
    },
    resetForm() {
      this.reportData = {
        name: '',
        phone: '',
        content: '',
        attachments: []
      };
      this.message.show = false;
    },
    // handleFileUpload(event) {
    //   const files = event.target.files;
    //   // 处理文件上传，这里简化处理
    //   for (let i = 0; i < files.length; i++) {
    //     this.reportData.attachments.push(files[i]);
    //   }
    // },
    // removeFile(index) {
    //   this.reportData.attachments.splice(index, 1);
    // },
    validateForm() {
      if (!this.reportData.name.trim()) {
        this.showMessage('请输入您的姓名', 'error');
        return false;
      }
      
      if (!this.reportData.phone.trim()) {
        this.showMessage('请输入您的联系电话', 'error');
        return false;
      }
      
      const phoneRegex = /^1[3456789]\d{9}$/;
      if (!phoneRegex.test(this.reportData.phone)) {
        this.showMessage('请输入正确的手机号码', 'error');
        return false;
      }
      
      if (!this.reportData.content.trim()) {
        this.showMessage('请输入举报内容', 'error');
        return false;
      }
      
      return true;
    },
    showMessage(text, type = 'info', duration = 3000) {
      this.message = {
        show: true,
        text,
        type
      };
      
      setTimeout(() => {
        this.message.show = false;
      }, duration);
    },
    async submitReport() {
      if (!this.validateForm()) {
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        // 构建举报内容，将姓名+联系电话+内容合并为content字段
        const content = `姓名：${this.reportData.name}\n联系电话：${this.reportData.phone}\n内容：${this.reportData.content}`;
        
        // 构建举报数据
        const reportData = {
          content: content,
          resourceType: this.resourceType,
          resourceId: parseInt(this.resourceId),
          attachments: [] // 如果需要实现附件上传，这里处理附件数组
        };
        
        // 调用API
        const response = await createReport(reportData);
        
        if (response && response.rc === 1) {
          this.showMessage('举报提交成功，我们会尽快处理', 'success');
          
          // 提交成功后重置表单
          setTimeout(() => {
            this.resetForm();
            this.$emit('success');
          }, 1500);
        } else {
          throw new Error(response?.msg || '提交失败');
        }
      } catch (error) {
        console.error('举报提交失败:', error);
        this.showMessage(error.message || '举报提交失败，请稍后重试', 'error');
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
.report-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.report-dialog {
  width: 480px;
  max-width: 90%;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  position: relative;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.report-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.report-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 16px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.required {
  color: #f56c6c;
  margin-left: 2px;
}

.form-input, .form-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
}

.form-input:focus, .form-textarea:focus {
  border-color: #4169e1;
  outline: none;
  box-shadow: 0 0 0 2px rgba(65, 105, 225, 0.2);
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

.file-input {
  display: block;
  margin-top: 8px;
}

.uploaded-files {
  margin-top: 8px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 4px;
  font-size: 12px;
}

.remove-file {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 16px;
}

.report-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn, .submit-btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.cancel-btn {
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}

.cancel-btn:hover {
  background-color: #e8e8e8;
}

.submit-btn {
  background: linear-gradient(90.00deg, rgb(150, 33, 254),rgb(26, 123, 238) 100%);
  color: white;
  border: none;
}

.submit-btn:hover {
  opacity: 0.9;
}

.submit-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.report-message {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

.info {
  background-color: #f4f4f5;
  color: #909399;
}

.success {
  background-color: #f0f9eb;
  color: #67c23a;
}

.warning {
  background-color: #fdf6ec;
  color: #e6a23c;
}

.error {
  background-color: #fef0f0;
  color: #f56c6c;
}
</style> 